var parser = require('./parser');

module.exports = {
	parse: parser.parse
}



//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/docker-file-parser/index.js
// module id = 439
// module chunks = 0